export var getStatusCardImageSectionSizes = (platform, size) => {
  var dimensions = {
    sm: {
      width: 72,
      height: 72
    },
    md: {
      width: 120,
      height: 120
    },
    lg: {
      width: 256,
      height: 256
    }
  };
  if (size) {
    return dimensions[size];
  } else {
    if (platform === 'web') {
      return dimensions.md;
    } else {
      return dimensions.sm;
    }
  }
};